import * as RoleType from "../../../../constants/user/RoleType"
import BlogSettingFormItem from "../BlogSettingFormItem"
import BlogEtcForm from "../BlogEtcForm"
import ManageDataForm from "../ManageDataForm"
import React from "react"
import BlogInfoForm from "./BlogInfoForm"
import ProfileForm from "./ProfileForm"
import BlogStatusForm from "./BlogStatusForm"

export default function({role}) {
  const canManageData = RoleType.canAccess(RoleType.convertStringToRoleType(role), RoleType.OWNER)
  return (
    <div className="blog_manage">
      <BlogSettingFormItem title='블로그 설정'>
        <BlogInfoForm />
      </BlogSettingFormItem>

      <BlogSettingFormItem title='프로필 설정'>
        <ProfileForm />
      </BlogSettingFormItem>

      <BlogSettingFormItem title='상태 설정'>
        <BlogStatusForm />
      </BlogSettingFormItem>

      <BlogSettingFormItem title='기타 설정'>
        <BlogEtcForm />
      </BlogSettingFormItem>

      { canManageData && <ManageDataForm /> }
    </div>
  )
}
